import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonDocumentLinkStyled,
  ColIconStyled,
  ColLinkStyled,
  ColPictureStyled,
  DivDocumentLinkStyled,
  DivImageContainerStyled,
  YoutubeIconDocumentLinkStyled,
  RowStyled,
  TypographyLinkTextStyled,
} from './styles';
import YoutubeIcon from '../../icons/social/Youtube';
import jsRedirect from '../../../helpers/jsRedirect';

const getIconForVariant = (variant) => {
  if (variant === 'youtube') {
    return <YoutubeIconDocumentLinkStyled />;
  }

  // default
  return <YoutubeIconDocumentLinkStyled />;
};

export const DocumentLinkComponent = ({
  buttonAriaLabel,
  buttonId,
  children,
  className,
  hasIcon,
  iconVariant,
  picSrc,
  targetUrl,
}) => {
  const documentLinkText = useRef();
  const addHoverState = () => {
    documentLinkText.current.classList.add('hover-state-active');
  };
  const removeHoverState = () => {
    documentLinkText.current.classList.remove('hover-state-active');
  };

  return (
    <DivDocumentLinkStyled
      className={className}
      hasIcon={hasIcon}>
      <RowStyled>
        {hasIcon ? (
          <ColIconStyled
            xsmall={3}
            large={3}>
            {getIconForVariant(iconVariant)}
          </ColIconStyled>
        ) : (
          <ColPictureStyled
            xsmall={4}
            large={4}>
            <DivImageContainerStyled
              lazyLoad={false}
              variant="primary"
              bgImage={picSrc}>
            </DivImageContainerStyled>
          </ColPictureStyled>
        )}
        <ColLinkStyled
          xsmall={8}
          large={8}>
          <TypographyLinkTextStyled
            component='p'
            ref={documentLinkText}>
            {children}
          </TypographyLinkTextStyled>
        </ColLinkStyled>
      </RowStyled>
      <ButtonDocumentLinkStyled
        id={buttonId}
        role='link'
        aria-label={buttonAriaLabel}
        onMouseOver={addHoverState}
        onMouseOut={removeHoverState}
        onFocus={addHoverState}
        onBlur={removeHoverState}
        onClick={() => {
          jsRedirect(targetUrl);
        }} />
    </DivDocumentLinkStyled>
  );
};

DocumentLinkComponent.propTypes = {
  buttonAriaLabel: PropTypes.string.isRequired,
  buttonId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hasIcon: PropTypes.bool,
  iconVariant: PropTypes.any,
  picSrc: PropTypes.string,
  targetUrl: PropTypes.string.isRequired,
};

DocumentLinkComponent.defaultProps = {
  iconVariant: YoutubeIcon,
  hasIcon: true,
};

export default DocumentLinkComponent;
